import React, { forwardRef } from "react";
import styles from "./svg.module.scss";
import globalStyles from "../../globalStyles";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import classnames from "classnames";
import type { SvgType } from "@whatslly/types/UI-V2/BaseElements/Svg/SvgTypes";
export const Svg = forwardRef<SVGSVGElement, SvgType>(
  (
    {
      iconName,
      disabled,
      color,
      backgroundColor,
      hoverColor,
      onClick,
      tooltipPlacement,
      id,
      toolTipText,
      width = 24,
      height = 24,
      borderRadius = "50%",
      className,
      tooltipClassName,
      ...props
    },
    ref
  ) => {
    const href = `#tvs-${iconName}`;
    const baseElement = (
      <svg
        ref={ref}
        onClick={onClick}
        style={{
          borderRadius: (backgroundColor || hoverColor) && borderRadius,
        }}
        className={classnames(
          globalStyles[`hover-bg-color-${hoverColor}`],
          globalStyles[`bg-color-${backgroundColor}`],
          { [styles.pointerEvents]: !disabled },
          className
        )}
        color={color}
        id={id}
        width={String(width)}
        height={String(height)}
        viewBox={`0 0 ${width} ${height}`}
        xmlns="http://www.w3.org/2000/svg"
        data-testid={props["data-testid"]}
      >
        <use href={href} />
      </svg>
    );

    return !tooltipPlacement || !toolTipText ? (
      baseElement
    ) : (
      <Tooltip className={tooltipClassName} placement={tooltipPlacement} value={<span>{toolTipText}</span>}>
        {baseElement}
      </Tooltip>
    );
  }
);
